import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {BonusBuyPopUpContent} from "@nolimitcity/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {FlightMode} from "../FlightMode";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {FlightModeGameData} from "./FlightModeData";
import {ASBonusPickOptions, ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {FlightModeGameAssets} from "../FlightModeGameAssets";
import {RestoreUtils} from "./RestoreUtils";
import GC_MAX_CHECK_COUNT = PIXI.settings.GC_MAX_CHECK_COUNT;

export class FlightModePromoPanelConfig implements PromoPanelGameConfiguration{

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Flight Mode",
            hasActionSpin: true,
            graphics: {
                backgroundTextureName: "resources/images/Intro_BG.jpg"
            },
            getParsedData: (response: FlightModeGameData, bet: number, prevResponse: FlightModeGameData):ASWinData => {
                return {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpins(response),
                    totalSpinWinnings: this.getTotalWin(response, prevResponse),
                    isBigWin: this.isBigWin(response, prevResponse),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response, prevResponse),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonudEnd(response),
                    isWinCapHit: response.brokeTheBank,
                }
            }
        };
    }

    private getTotalWin(response: FlightModeGameData, prevResponse:FlightModeGameData):number {
        return response.mode == "EXTRA_SPIN"
            ? prevResponse != undefined
                ? prevResponse.spinWin
                : response.accumulatedRoundWin
            : response.spinWin;
    }

    private isFreeSpins(response:any){
        return (response.mode == GameMode.NORMAL || response.mode == "NORMAL_AVALANCHE") &&
               (response.nextMode == GameMode.FREESPIN);
    }

    private getWinSize(response:FlightModeGameData) {
        return response.spinWin;
    }

    private getFeatureName(response: FlightModeGameData, prevResponse: FlightModeGameData): string {
        const relevantResponse = response.mode == "EXTRA_SPIN" ? prevResponse : response;

        if (relevantResponse == undefined || relevantResponse.mode == "RESPIN")
            return "NORMAL";

        if (relevantResponse.mode == GameMode.FREESPIN ||
            relevantResponse.nextMode == GameMode.FREESPIN ||
            relevantResponse.mode == "FREESPIN_AVALANCHE"||
            relevantResponse.nextMode == "FREESPIN_AVALANCHE"){
            return "FLEE SPINS"
        }

        return relevantResponse.mode;
    }

    private isBonudEnd(response: FlightModeGameData):boolean {
        return response.mode != GameMode.NORMAL && response.nextMode == GameMode.NORMAL;
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN)
            FlightMode.soundPlayer.playSound("asWin");
        else if (trigger == ActionSpinSound.BIG_WIN)
            FlightMode.soundPlayer.playSound("asBigWin");
    }

    private isBigWin(response:FlightModeGameData, prevResponse:FlightModeGameData): boolean {
        const win = this.getTotalWin(response, prevResponse);
        const winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 5);
        const expensiveWinRatio = Helper.ceilToDecimals((win / FlightMode.getBetPrice()), 5);

        const smallThreshold =
            response.wasFeatureBuy || (FlightMode.getBetPrice() / response.playedBetValue) > 15;

        return smallThreshold ? expensiveWinRatio >= 1 : winRatio >= 15;
    }

    private isRoundComplete(response: FlightModeGameData): boolean {
        return  ([GameMode.FREESPIN, GameMode.NORMAL,].indexOf(response.nextMode) > -1);
    }

    public onPlayBonusInGame(data: any) {
        FlightMode.model.onGame(data);
        RestoreUtils.playBonusInGame();
        setTimeout(() => {
            FlightMode.gameFlowController.start();
        }, 300);
    }
}